import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user/user.services';
import { OrganismService } from 'src/app/partners/organisms/organisms.service';
import { OrganismModel } from 'src/app/partners/organisms/organism.model';
import { IsRowMaster } from 'ag-grid-community/dist/lib/entities/gridOptions';
import { MasterService } from 'src/app/masters/master.service';
import { CountryModel } from 'src/app/masters/country/country.model';
import { UserModel } from 'src/app/user/add-user/user.model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import * as CommonConstants from '../../utils/common.constants';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  organismSearch:OrganismModel=new OrganismModel();
  profileList:any=[];
  organismList:OrganismModel[]=[];
  partnerList:any[]=[];
  subProfileList:any[]=[];
  countryList:CountryModel[]=[];
  languageList:any[]=[];
  appList:any[]=[];
  contactList:any[]=[];
  user:UserModel=new UserModel();
  userform: FormGroup;  
  submitted=false;
  partnerType;
  partId: number;

  
  
  constructor(private formBuilder: FormBuilder,private userService:UserService,private organismService:OrganismService,private masterService:MasterService,private toasterService : ToastrService) { 
   
    this.getFromGroup();    
  }
  reset(){
    this.userform.reset();
  }
  ngOnInit() {
    this.loadOrganisms();
    this.loadProfile();
    this.loadCountry();
    this.loadLangauges();
    this.loadApplications();    
  }
 
  loadProfile(){
    this.userService.getProfile().subscribe(response => {
      
      this.profileList = response['result'];
    })
  }
  loadOrganisms(){
    this.organismService.searchOrganisms(this.organismSearch).subscribe(response => {
      this.organismList = response['result'];
    })
  }
  loadPartnersByProfile(pType:number){
    this.organismService.loadPartners(pType).subscribe(response => {
      this.partnerList = response['result'];
      if(this.partId){
        this.loadContacts(this.partId);
        this.partId=null;
      }
      
    })
  }
  onChangeProfile(profileId){
    this.partnerType=this.profileList.filter(profile => profile.secProId === +profileId.target.value)[0].partnerType;
    this.loadDetailsByProfileId(profileId.target.value);
    
  }
  onChangeProfileByPatch(profileId){
    this.partnerType=this.profileList.filter(profile => profile.secProId === +profileId)[0].partnerType;
    this.loadDetailsByProfileId(profileId);
    
  }
  loadDetailsByProfileId(profileId:number){
    this.userService.getSubProfileByProfileId(profileId).subscribe(response => {
      this.subProfileList = response['result'];
    })
    this.loadPartnersByProfile(this.partnerType);
  }
  loadCountry(){
    this.masterService.getCountry().subscribe(response => {
      this.countryList = response['result'];
    })
  }
  loadLangauges(){
    this.masterService.getLanguages().subscribe(response => {
      this.languageList = response['result'];
    })
  }
  loadApplications(){
    this.userService.getApplications().subscribe(response => {
      this.appList = response['result'];
    })
  }
  loadContacts(partnerId){
    let pid=partnerId.target?partnerId.target.value:partnerId;
    let organismId=this.partnerList.filter(partner => partner.partnerid === +pid)[0].orgsmId;
    this.userform.patchValue({orgsmId:organismId});
    this.masterService.getEmployeesByPartnerId(this.partnerType,pid).subscribe(response => {
      this.contactList = response['result'];
    })
  }
  createUser(){
    if(!this.f.secUsrId.value){
      if(!this.f.secUsrLogin.value){
        swal.fire("Error",'Please Provide Login id','error')
        return;
      }
      else if(!this.f.secUsrPwd.value){
        swal.fire("Error",'Please Provide Password','error')
        return;
      }
      else if(!this.f.secUsrCnfrmPwd.value){
        swal.fire("Error",'Please Provide confirm password','error')
        return;
      }
      if(this.f.secUsrCnfrmPwd.value!=this.f.secUsrPwd.value){
        swal.fire("Error",'Password and Confirm Password do not match','error')
        return;
      }
    }
    this.submitted = true; if (this.userform.invalid) {
      return;
    }
    let userDetails={
      "orgsmId": this.userform.value.orgsmId,
      "sudeaId":this.userform.value.sudeaId,
      "partnerId": this.userform.value.partnerId,
      "empyeeId": this.userform.value.empyeeId,
      "cotryIdDefault": this.userform.value.cotryIdDefault,
      "languCode": this.userform.value.languCode,
      "secProId": this.userform.value.secProId,
      "secSubProId": this.userform.value.secSubProId,
      "partnerType": this.partnerType,
      "applicationId":+this.userform.value.applicationId,
    };
    let saveData = {
        "secUsrId":this.userform.value.secUsrId,
        "secProId": this.userform.value.secProId,
        //"secSubProId": this.userform.value.secSubProId,
        "secUsrLogin": this.userform.value.secUsrLogin,
        "secUsrPwd": this.userform.value.secUsrPwd,
        "secUsrCnfrmPwd": this.userform.value.secUsrCnfrmPwd,
        'staRecCode':this.userform.value.staRecCode?'A':'I',
        "secUsrEmail":this.userform.value.secUsrEmail,
        "tuSecUserDetail": userDetails
    }
    
    this.userService.saveUser(saveData).subscribe(response => {
      if (response && response["code"]==0) {
        this.userform.patchValue({secUsrId: response['result']});
        //this.toasterService.success(response['message'], 'Success');
        swal.fire("Success", response['message'], 'success');
      }else{
        swal.fire("Error", response['message'], 'error');
      }
    })
   
    /* if(this.user){
    let res = this.http.post(CommonConstants.CREATE_USER, this.user)
      .subscribe(response => {
        if (response['code'] == 0) {

          console.log("Saved successfully the server");
        } else {

        }

      });
    } */
  }
  patchFormValues(item:any){
    this.partId=item.tuSecUserDetail.partnerId;
    this.reset();
    setTimeout(() => {
      this.onChangeProfileByPatch(item.tuSecUserDetail.secProId);
      this.userform.patchValue(
        {
          secUsrId:item.secUsrId,
          secProId:item.tuSecUserDetail.secProId,
          sudeaId:item.tuSecUserDetail.sudeaId,
          secSubProId: item.tuSecUserDetail.secSubProId,
          orgsmId: item.tuSecUserDetail.orgsmId,
          partnerId: item.tuSecUserDetail.partnerId,
          empyeeId: item.tuSecUserDetail.empyeeId,
          cotryIdDefault:  item.tuSecUserDetail.cotryIdDefault,
          languCode: item.tuSecUserDetail.languCode,
          applicationId: item.tuSecUserDetail.applicationId,
          secUsrEmail:item.secUsrEmail,
          staRecCode:item.staRecCode==='A'? true:false
        }
      )
    }, 1000);
    
  }
  get f() { return this.userform.controls; }

  private getFromGroup() {
    this.userform = this.formBuilder.group({
      'secUsrId':[null],
      'sudeaId':[null],
      'secProId': [new FormControl(), Validators.required],
      'secSubProId': [new FormControl(), Validators.required],
      'orgsmId': [new FormControl(), Validators.required],
      'partnerId': [new FormControl(), Validators.required],
      'empyeeId': [new FormControl(), Validators.required],
      'secUsrLogin': new FormControl(),
      'secUsrPwd':  new FormControl(),
      'secUsrCnfrmPwd': new FormControl(),
      'cotryIdDefault':  [new FormControl(), Validators.required],
      'languCode': new FormControl(),
      'applicationId': [new FormControl(), Validators.required],
      'secUsrEmail': new FormControl('', Validators.compose([Validators.required, Validators.email])),
      'staRecCode':[true]
    })
  }
}
